const headerLinks = [
  { name: "Pricing", href: "/" },
  { name: "Product", href: "/" },
  { name: "About us", href: "/" },
  { name: "Careers", href: "/" },
  { name: "Community", href: "/" },
];

export default headerLinks;
